<template>
  <p-edit-tool v-if="$hasPermission('prompts.read')" />
  <p-not-found v-else />
</template>

<script>
import EditTool from '@/components/tools/EditTool.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-edit-tool': EditTool,
    'p-not-found': NotFound
  }
};
</script>
